<span class="p-dialog-title">{{ "profile_settings.title" | translate }}</span>
